import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@mui/material/CircularProgress'
import Skeleton from '@mui/material/Skeleton'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { selectThemeMode } from '../../Core/Redux/Theme'
import { range } from 'ramda'

const Wrapper = styled.div`
  align-items: center;
  display: ${({ display }) => display};
  flex-direction: column;
  justify-content: center;
  min-height: ${(props) => (props.overlay ? 'auto' : props.minHeight)};
  ${(props) =>
    props.overlay
      ? props.theme === 'light'
        ? 'background: rgba(255, 255, 255, .7)'
        : 'background: rgba(0, 0, 0, .7)'
      : ''};
  ${(props) => (props.overlay ? (props.absolute ? 'position: absolute' : 'position: fixed') : '')};
  ${(props) => (props.overlay ? 'top: 0' : '')};
  ${(props) => (props.overlay ? 'bottom: 0' : '')};
  ${(props) => (props.overlay ? 'right: 0' : '')};
  ${(props) => (props.overlay ? 'left: 0' : '')};
  ${(props) => (props.overlay ? 'z-index: 10000' : '')};
`

const Loader = ({
  show,
  minHeight,
  size,
  overlay,
  absolute,
  skeleton,
  justifyStart,
  color,
  text,
  display,
  style,
  skeletonHeight,
}) => {
  const theme = useSelector(selectThemeMode)
  if (!show) return null
  return (
    <Wrapper
      minHeight={minHeight}
      overlay={overlay}
      absolute={absolute}
      justifyStart={justifyStart}
      theme={theme}
      display={display}
      style={style}
    >
      {skeleton && (
        <div style={{ width: '100%' }}>
          {range(0, skeleton).map((idx) => (
            <Skeleton animation="pulse" key={idx} height={skeletonHeight} style={{ transform: 'scale(1,0.8)' }} />
          ))}
        </div>
      )}
      {!skeleton && <CircularProgress color={color} size={size}></CircularProgress>}
      {text && <p>{text}</p>}
    </Wrapper>
  )
}

Loader.defaultProps = {
  show: true,
  minHeight: '0',
  size: 40,
  skeleton: false,
  skeletonHeight: 45,
  justifyStart: false,
  color: 'primary',
  display: 'flex',
  style: {},
}

Loader.propTypes = {
  show: PropTypes.bool,
  minHeight: PropTypes.string,
  size: PropTypes.number,
  overlay: PropTypes.bool,
  skeleton: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  skeletonHeight: PropTypes.number,
  justifyStart: PropTypes.bool,
  absolute: PropTypes.bool,
  color: PropTypes.string,
  text: PropTypes.string,
  display: PropTypes.string,
  style: PropTypes.object,
}

export default Loader
